import { tabCloser, tabTemplate, categoryTab } from '@/layout/state/state';
import { matchSingleUrl } from '@/constants/urls';
import { closeSearches } from '../actions';
import SearchesActions from '../containers/SearchesActions';
import SearchesPanel from '../components/SearchesPanel';

export default {
  ...tabTemplate('searches', SearchesPanel, matchSingleUrl(['searches']), SearchesActions),
  ...tabCloser('closeSearchesTab', closeSearches),
  access: ({ search }) => search.read,
  componentState: ({ url }) => categoryTab(url, 'saved'),
  order: 105,
  position: 'bottom-right',
  icon: 'fas fa-list-alt',
  dropDownIcon: 'list alternate',
};
